<template>
  <div class="internal-fee-markup-rule" style="height: 100%; display: flex; flex-direction: column;">
    <!-- 检索条件区域 -->
    <div class="cargo-advance-search" style="width: 100%; margin-top: 5px; min-width: 1280px">
      <div class="section">
        <el-form label-position="left" label-width="65px" :inline="true">
          <el-row style="margin-bottom: 5px;" :gutter="10">
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_FeeName')">
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_ChargeItem"
                  clearable
                  filterable
                  :default-value="filter.feeItemId"
                  @parentCallBack="p => { filter.feeName = p.tagName; filter.feeItemId = p.value }"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('CargoMsg.Cargo_Status')" label-width="45px">
                <el-select v-model="filter.enabled" clearable style="width: 100%">
                  <el-option :label="$t('CargoMsg.Cargo_AllStatus')" value="all" />
                  <el-option :label="$t('CargoMsg.Cargo_Enabled')" value="1" />
                  <el-option :label="$t('CargoMsg.Cargo_Disabled')" value="0" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="text-align: left">
              <el-button type="primary" @click="toQuery">{{ $t('CargoMsg.Cargo_Query') }}</el-button>
              <el-button type="default" @click="toReset">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
              <el-button type="primary" @click="toAdd">{{ $t('CargoMsg.Cargo_AddRule') }}</el-button>
              <el-button type="danger" @click="toBatchDelete">{{ $t('CargoMsg.Cargo_BatchDelete') }}</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <!-- 列表区域 -->
    <div class="grid-view" style="flex-grow: 1; display: flex; flex-direction: column;">
      <div class="main-content" style="flex-grow: 1;">
        <div class="section grid-wrapper">
          <cargo-ag-grid
            config-module="261701"
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            @gridReady="params => { this.gridApi = params.api }"
            @selection-changed="onSelectionChanged"
          />
        </div>
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="261701"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialog.isView ? $t('CargoMsg.Cargo_Details') : (dialog.isEdit ? $t('CargoMsg.Cargo_EditRule') : $t('CargoMsg.Cargo_AddRule'))"
      :visible.sync="dialog.visible"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
      custom-class="internal-fee-markup-rule-dialog"
    >
      <el-form ref="ruleForm" :model="dialog.form" label-width="120px" :rules="dialog.rules" :disabled="dialog.isView">
        <el-form-item :label="$t('CargoMsg.Cargo_FeeName')" prop="feeName">
          <cargo-advance-select
            ref="dialogFeeSelect"
            :select-type="selectTypeNames.basic_data_ChargeItem"
            clearable
            filterable
            :placeholder="$t('CargoMsg.Cargo_PleaseFill') + $t('CargoMsg.Cargo_FeeName')"
            :default-value="dialog.form.feeItemId"
            @parentCallBack="onFeeNameChange"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_IncomeExpenseType')" prop="incomeExpenseType">
          <el-select v-model="dialog.form.incomeExpenseType" style="width: 100%">
            <el-option :label="$t('CargoMsg.Cargo_Receivable')" value="AR" />
            <el-option :label="$t('CargoMsg.Cargo_AccountsPayable')" value="AP" />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_MarkupType')" prop="markupType">
          <el-radio-group v-model="dialog.form.markupType" @change="handleMarkupTypeChange">
            <el-radio label="FIXED">{{ $t('CargoMsg.Cargo_FixedAmount') }}</el-radio>
            <el-radio label="PERCENT">{{ $t('CargoMsg.Cargo_PercentMarkup') }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_MarkupValue')" prop="markupValue">
          <el-input
            v-model="dialog.form.markupValue"
            :placeholder="markupValuePlaceholder"
            @input="handleMarkupValueInput"
            @blur="onMarkupValueBlur"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ApplicableCompany')">
          <el-popover
            v-model="companyPopoverVisible"
            placement="bottom-start"
            width="400"
            trigger="click"
            popper-class="company-tree-popper"
          >
            <div class="company-tree-wrapper" style="max-height: 280px; overflow-y: auto;">
              <el-tree
                ref="companyTree"
                :data="officeTreeOptions"
                node-key="value"
                :default-expanded-keys="expandedKeys"
                :render-content="renderCompanyNode"
                @node-click="onCompanyNodeClick"
              />
            </div>
            <div slot="reference" class="company-select-trigger">
              <el-input
                :value="selectedCompanyLabels"
                readonly
                suffix-icon="el-icon-arrow-down"
                :placeholder="$t('CargoMsg.Cargo_PleaseSelect') + $t('CargoMsg.Cargo_ApplicableCompany')"
              />
            </div>
          </el-popover>
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_EnabledStatus')">
          <el-checkbox v-model="dialog.form.enabledBool">{{ $t('CargoMsg.Cargo_Enable') }}</el-checkbox>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialog.visible = false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        <el-button v-show="!dialog.isView" type="primary" @click="onSave">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { DocumentManage } from '@/utils/commonUtil'
import { getLoading } from '@/utils/utilBaseElement'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { query, add, edit, setEnabled, batchDelete } from '@/api/sysManage/baseConfig/internalFeeMarkupRule'

export default {
  name: 'InternalFeeMarkupRule',
  components: { CargoAdvanceSelect },
  data() {
    return {
      loading: false,
      selectTypeNames: TYPE_NAMES,
      documentManage: new DocumentManage(),
      gridParams: {},
      gridApi: null,
      selectRow: null,
      selectedRows: [],
      officeTreeOptions: [],
      expandedKeys: [],
      companyPopoverVisible: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: event => {
          this.selectRow = event.data
        }
      },
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 20,
        feeName: '',
        feeItemId: null,
        enabled: 'all'
      },
      rowData: [],
      dialog: {
        visible: false,
        isEdit: false,
        isView: false,
        form: {
          uuid: '',
          feeName: '',
          feeItemId: null,
          incomeExpenseType: 'AP',
          markupType: 'FIXED',
          markupValue: '',
          applicableCompanyIds: [],
          enabledBool: false
        },
        rules: {
          feeName: [{ required: true, message: this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_FeeName'), trigger: 'change' }],
          incomeExpenseType: [{ required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_IncomeExpenseType'), trigger: 'change' }],
          markupType: [{ required: true, message: this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_MarkupType'), trigger: 'change' }],
          markupValue: [{ required: true, validator: this.validateMarkupValue, trigger: 'blur' }]
        }
      }
    }
  },
  computed: {
    selectedCompanyLabels() {
      const ids = this.dialog.form.applicableCompanyIds || []
      if (ids.length === 0) return ''
      const rootId = this.officeTreeOptions[0]?.value
      if (rootId && ids.includes(rootId)) {
        return this.officeTreeOptions[0]?.label || ''
      }
      const labels = []
      const collectLabels = (options) => {
        for (const opt of options) {
          if (opt.children) {
            collectLabels(opt.children)
          } else if (ids.includes(opt.value)) {
            labels.push(opt.label)
          }
        }
      }
      collectLabels(this.officeTreeOptions)
      return labels.join(', ')
    },
    markupValuePlaceholder() {
      const base = this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_MarkupValue')
      if (this.dialog.form.markupType === 'PERCENT') {
        return base + '(如: 10%)'
      }
      return base + '(如: 100.00)'
    },
    columnDefs() {
      return [
        { headerName: '', colId: 'checkbox', width: 55, checkboxSelection: true, sortable: false, suppressSizeToFit: true, resizable: false, headerCheckboxSelection: true },
        { headerName: this.$t('CargoMsg.Cargo_SequenceNumber'), field: 'serialNumber', width: 60, sortable: false },
        { headerName: this.$t('CargoMsg.Cargo_FeeName'), field: 'feeName', flex: 1 },
        {
          headerName: this.$t('CargoMsg.Cargo_IncomeExpenseType'),
          field: 'incomeExpenseType',
          width: 100,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return params.value === 'AR' ? this.$t('CargoMsg.Cargo_Receivable') : this.$t('CargoMsg.Cargo_AccountsPayable')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_MarkupType'),
          field: 'markupType',
          width: 120,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return params.value === 'FIXED' ? this.$t('CargoMsg.Cargo_FixedAmount') : this.$t('CargoMsg.Cargo_PercentMarkup')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_MarkupValue'), field: 'markupValue', width: 100 },
        {
          headerName: this.$t('CargoMsg.Cargo_ApplicableCompany'),
          field: 'applicableCompany',
          flex: 1,
          valueFormatter: (params) => {
            if (!params.value) return ''
            return this.formatApplicableCompany(String(params.value))
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Status'),
          field: 'enabled',
          width: 80,
          cellRenderer: (params) => {
            if (!params.value) return ''
            const enabled = String(params.value) === '1'
            const text = enabled ? this.$t('CargoMsg.Cargo_Enabled') : this.$t('CargoMsg.Cargo_Disabled')
            const color = enabled ? '#92c74e' : '#d9031d'
            return `<span style="color:${color};">${text}</span>`
          }
        },
        { headerName: this.$t('SeaExport.DateOfCreation2'), field: 'dateCreated', width: 160,
          cellRenderer: params => ColumnUtils.dateTimeLabelFunc(params.value)
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: 'enabled',
          colId: 'operation',
          width: 160,
          cellRenderer: params => {
            const toEdit = this.documentManage.getPath('toEditRule')
            const toChangeEnabled = this.documentManage.getPath('toChangeEnabled')
            const toViewRule = this.documentManage.getPath('toViewRule')
            const uuid = "'" + params.data.uuid + "'"
            if (String(params.value) === '1') {
              const name = this.$t('CargoMsg.Cargo_Disable')
              const detailName = this.$t('CargoMsg.Cargo_CooperateLogContent')
              return `<div onclick="${toChangeEnabled}(${uuid}, '0')" style="display: inline-block;color:rgba(217, 3, 29);margin-right: 10px;cursor: pointer">${name}</div>` +
                `<div onclick="${toViewRule}(${uuid})" style="display: inline-block;color:#409EFF;cursor: pointer">${detailName}</div>`
            } else {
              const editName = this.$t('CargoMsg.Cargo_Edit')
              const enableName = this.$t('CargoMsg.Cargo_Enable')
              return `<div onclick="${toEdit}(${uuid})" style="display: inline-block;color:#409EFF;margin-right: 10px;cursor: pointer">${editName}</div>` +
                `<div onclick="${toChangeEnabled}(${uuid}, '1')" style="display: inline-block;color:rgba(146, 199, 63);cursor: pointer">${enableName}</div>`
            }
          }
        }
      ]
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('toEditRule', function(uuid) {
      context.handleEditByUuid(uuid)
    })
    this.documentManage.set('toChangeEnabled', function(uuid, enabled) {
      context.handleChangeEnabled(uuid, enabled)
    })
    this.documentManage.set('toViewRule', function(uuid) {
      context.handleViewByUuid(uuid)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  created() {
    this.toQuery()
  },
  methods: {
    onSelectionChanged() {
      this.selectedRows = this.gridApi ? this.gridApi.getSelectedRows() : []
    },
    loadOfficeTree() {
      const offices = getCacheListByKey(TYPE_NAMES.basic_data_Office) || []
      this.officeTreeOptions = this.buildOfficeTree(offices)
    },
    buildOfficeTree(offices) {
      const isZh = this.$store.getters.language === 'zh'
      const virtualParentOffice = offices.find(item => !item.parentBranchUuid) || offices[0]
      if (!virtualParentOffice) return []
      const rootOffice = {
        value: virtualParentOffice.officeId,
        label: isZh ? virtualParentOffice.chineseName : (virtualParentOffice.englishName || virtualParentOffice.chineseName),
        children: []
      }
      for (const office of offices) {
        if (office.uuid !== virtualParentOffice.uuid) {
          rootOffice.children.push({
            value: office.officeId,
            label: isZh ? office.chineseName : (office.englishName || office.chineseName)
          })
        }
      }
      return [rootOffice]
    },
    onCompanyNodeClick(data) {
      const companyIds = [...(this.dialog.form.applicableCompanyIds || [])]
      const index = companyIds.indexOf(data.value)
      if (index > -1) {
        // 取消选中
        companyIds.splice(index, 1)
        if (data.children) {
          // 取消父节点时，同时取消所有子节点
          data.children.forEach(child => {
            const childIndex = companyIds.indexOf(child.value)
            if (childIndex > -1) {
              companyIds.splice(childIndex, 1)
            }
          })
        }
      } else {
        // 选中
        companyIds.push(data.value)
        if (data.children) {
          // 选中父节点时，同时选中所有子节点
          data.children.forEach(child => {
            if (!companyIds.includes(child.value)) {
              companyIds.push(child.value)
            }
          })
        }
      }
      // 检查父子联动：如果取消某个子公司，其父公司也应取消
      this.syncParentSelection(companyIds)
      this.dialog.form.applicableCompanyIds = companyIds
    },
    syncParentSelection(companyIds) {
      // 遍历树，检查每个父节点的子节点是否全部选中
      // 如果子节点未全部选中，则取消父节点选中状态
      for (const rootNode of this.officeTreeOptions) {
        if (rootNode.children && rootNode.children.length > 0) {
          const allChildrenSelected = rootNode.children.every(child => companyIds.includes(child.value))
          const parentIndex = companyIds.indexOf(rootNode.value)
          if (!allChildrenSelected && parentIndex > -1) {
            // 子节点未全部选中，取消父节点
            companyIds.splice(parentIndex, 1)
          } else if (allChildrenSelected && parentIndex === -1) {
            // 子节点全部选中，自动选中父节点
            companyIds.push(rootNode.value)
          }
        }
      }
    },
    formatApplicableCompany(value) {
      const ids = String(value).split(',').filter(v => v)
      const rootId = this.officeTreeOptions[0]?.value
      if (rootId && ids.includes(String(rootId))) {
        return this.officeTreeOptions[0]?.label || ''
      }
      return ids.map(id => {
        const label = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', Number(id), 'chineseName')
        return label || id
      }).join(', ')
    },
    renderCompanyNode(h, { node, data }) {
      const isSelected = this.dialog.form.applicableCompanyIds.includes(data.value)
      return h('span', {
        style: {
          padding: '4px 8px',
          display: 'block',
          cursor: 'pointer',
          backgroundColor: isSelected ? '#eef5ff' : 'transparent',
          color: isSelected ? '#409EFF' : '#606266'
        }
      }, data.label)
    },
    validateMarkupValue(rule, value, callback) {
      const baseMsg = this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_MarkupValue')
      const str = String(value == null ? '' : value).trim()
      if (!str) {
        callback(new Error(baseMsg))
        return
      }
      if (this.dialog.form.markupType === 'FIXED') {
        if (!/^\d+(\.\d{1,2})?$/.test(str)) {
          callback(new Error(this.$t('CargoMsg.Cargo_MarkupValueFixedTip')))
          return
        }
      } else if (this.dialog.form.markupType === 'PERCENT') {
        if (!/^\d+(\.\d+)?%$/.test(str)) {
          callback(new Error(this.$t('CargoMsg.Cargo_MarkupValuePercentTip')))
          return
        }
      }
      callback()
    },
    onFeeNameChange(p) {
      // cargoAdvanceSelect 回调对象是 {...selectedItem, value, isManualEntry}
      // 费用名称对应的字段名取决于组件的 ownTagName（中文为zhName，英文为enName）
      const tagNameField = (this.$refs.dialogFeeSelect && this.$refs.dialogFeeSelect.ownTagName) || 'zhName'
      this.dialog.form.feeName = p[tagNameField] || ''
      this.dialog.form.feeItemId = p.value
      this.$nextTick(() => {
        if (this.$refs.ruleForm) this.$refs.ruleForm.validateField('feeName')
      })
    },
    handleMarkupTypeChange() {
      this.dialog.form.markupValue = ''
      this.$nextTick(() => {
        if (this.$refs.ruleForm) this.$refs.ruleForm.clearValidate('markupValue')
      })
    },
    handleMarkupValueInput(val) {
      if (this.dialog.form.markupType === 'FIXED') {
        let filtered = val.replace(/[^\d.]/g, '')
        const parts = filtered.split('.')
        if (parts.length > 2) filtered = parts[0] + '.' + parts.slice(1).join('')
        if (parts.length === 2 && parts[1].length > 2) filtered = parts[0] + '.' + parts[1].substring(0, 2)
        this.dialog.form.markupValue = filtered
      } else if (this.dialog.form.markupType === 'PERCENT') {
        let filtered = val.replace(/[^\d.%]/g, '')
        const hasPercent = filtered.includes('%')
        filtered = filtered.replace(/%/g, '')
        const parts = filtered.split('.')
        if (parts.length > 2) filtered = parts[0] + '.' + parts.slice(1).join('')
        filtered = hasPercent ? filtered + '%' : filtered
        this.dialog.form.markupValue = filtered
      }
    },
    onMarkupValueBlur() {
      // 百分比类型失焦时自动补齐百分号
      if (this.dialog.form.markupType === 'PERCENT') {
        const str = String(this.dialog.form.markupValue || '').trim()
        if (str && !str.endsWith('%')) {
          this.dialog.form.markupValue = str + '%'
        }
      }
    },
    toQuery() {
      const params = {
        feeName: this.filter.feeName || '',
        enabled: this.filter.enabled || 'all',
        pageNum: this.filter.pageNum,
        pageSize: this.filter.pageSize
      }
      this.loading = getLoading()
      query(params).then(res => {
        this.rowData = res.data.list || []
        ColumnUtils.addSerialNumber(this.rowData)
        this.filter.total = Number(res.data.total)
      }).finally(() => {
        this.loading.close()
      })
    },
    toReset() {
      this.filter.feeName = ''
      this.filter.feeItemId = null
      this.filter.enabled = 'all'
      this.filter.pageNum = 1
      this.toQuery()
    },
    toAdd() {
      this.dialog.isEdit = false
      this.dialog.isView = false
      this.dialog.form = {
        uuid: '',
        feeName: '',
        feeItemId: null,
        incomeExpenseType: 'AP',
        markupType: 'FIXED',
        markupValue: '',
        applicableCompanyIds: [],
        enabledBool: false
      }
      this.loadOfficeTree()
      this.$nextTick(() => {
        if (this.officeTreeOptions.length > 0) {
          this.expandedKeys = [this.officeTreeOptions[0].value]
        }
        this.dialog.visible = true
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate()
        }
      })
    },
    handleEditByUuid(uuid) {
      const row = this.rowData.find(item => item.uuid === uuid)
      if (!row) return
      this.toEdit(row)
    },
    handleViewByUuid(uuid) {
      const row = this.rowData.find(item => item.uuid === uuid)
      if (!row) return
      this.toView(row)
    },
    toView(row) {
      this.dialog.isView = true
      this.dialog.isEdit = false
      const applicableCompanyIds = row.applicableCompany
        ? String(row.applicableCompany).split(',').filter(v => v).map(v => Number(v))
        : []
      this.loadOfficeTree()
      this.dialog.form = {
        uuid: row.uuid,
        feeName: row.feeName,
        feeItemId: row.feeId != null ? Number(row.feeId) : null,
        incomeExpenseType: row.incomeExpenseType || 'AP',
        markupType: row.markupType || 'FIXED',
        markupValue: row.markupValue != null ? String(row.markupValue) : '',
        applicableCompanyIds: applicableCompanyIds,
        enabledBool: String(row.enabled) === '1'
      }
      this.$nextTick(() => {
        if (this.officeTreeOptions.length > 0) {
          this.expandedKeys = [this.officeTreeOptions[0].value]
        }
        this.dialog.visible = true
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate()
        }
      })
    },
    toEdit(row) {
      this.dialog.isEdit = true
      this.dialog.isView = false
      const applicableCompanyIds = row.applicableCompany
        ? String(row.applicableCompany).split(',').filter(v => v).map(v => Number(v))
        : []
      this.loadOfficeTree()
      this.dialog.form = {
        uuid: row.uuid,
        feeName: row.feeName,
        feeItemId: row.feeId != null ? Number(row.feeId) : null,
        incomeExpenseType: row.incomeExpenseType || 'AP',
        markupType: row.markupType || 'FIXED',
        markupValue: row.markupValue != null ? String(row.markupValue) : '',
        applicableCompanyIds: applicableCompanyIds,
        enabledBool: String(row.enabled) === '1'
      }
      this.$nextTick(() => {
        if (this.officeTreeOptions.length > 0) {
          this.expandedKeys = [this.officeTreeOptions[0].value]
        }
        this.dialog.visible = true
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.clearValidate()
        }
      })
    },
    onSave() {
      this.$refs.ruleForm.validate(valid => {
        if (!valid) return
        const applicableCompany = (this.dialog.form.applicableCompanyIds || []).join(',')
        const data = {
          uuid: this.dialog.form.uuid,
          feeId: String(this.dialog.form.feeItemId || ''),
          feeName: this.dialog.form.feeName,
          incomeExpenseType: this.dialog.form.incomeExpenseType,
          markupType: this.dialog.form.markupType,
          markupValue: this.dialog.form.markupValue,
          applicableCompany: applicableCompany,
          enabled: this.dialog.form.enabledBool ? '1' : '0'
        }
        this.loading = getLoading()
        const apiCall = this.dialog.isEdit ? edit(data) : add(data)
        apiCall.then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          this.dialog.visible = false
          this.toQuery()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    handleChangeEnabled(uuid, enabled) {
      this.loading = getLoading()
      setEnabled({ uuid, enabled }).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_EditedSuccessfully'))
        this.toQuery()
      }).finally(() => {
        this.loading.close()
      })
    },
    toBatchDelete() {
      const selectedRows = this.selectedRows || []
      if (selectedRows.length === 0) {
        this.$message.warning('请选择要删除的记录!')
        return
      }
      for (const row of selectedRows) {
        if (String(row.enabled) === '1') {
          this.$message.warning('不能删除启用状态的数据')
          return
        }
      }
      this.$confirm(this.$t('CargoMsg.Cargo_DeleteConfirm'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        type: 'warning'
      }).then(() => {
        const uuids = selectedRows.map(row => row.uuid)
        this.loading = getLoading()
        batchDelete(uuids).then(res => {
          this.toQuery()
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.internal-fee-markup-rule {
  .grid-view {
    .main-content {
      .grid-wrapper {
        height: 100%;
      }
    }
  }
  .el-tree-node.is-selected > .el-tree-node__content {
    background-color: #eef5ff !important;
    color: #409EFF;
  }
}
</style>

<style lang="scss">
.internal-fee-markup-rule-dialog {
  .el-form-item {
    margin-bottom: 32px !important;
  }
  .el-form-item__error {
    position: relative !important;
    top: auto !important;
    margin-top: 4px !important;
    padding-top: 0 !important;
    float: left;
    clear: both;
  }
  .el-dialog__body {
    padding-bottom: 15px;
  }
  .company-select-trigger {
    .el-input__inner {
      cursor: pointer;
    }
    .el-input__suffix {
      transition: transform 0.3s;
    }
  }
}
.company-tree-popper {
  .el-tree-node__content {
    height: 34px;
  }
  .el-tree-node__expand-icon {
    cursor: pointer;
  }
}
</style>

